<template>
  <div class="footer">
    <div class="footerActions">
      <SanitasButton
        v-if="position > 0 && enablePrev"
        secondary
        class="back"
        @click="prevPage"
      >
        {{ texts.back }}
      </SanitasButton>
      <SanitasButton
        primary
        class="next"
        :disabled="!this.getAllowDK && !this.isValid"
        :isSpinnerActive="isLoading"
        @click="handleClickNextPage"
      >
        {{ texts.next }}
      </SanitasButton>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import SanitasButton from '../common/SanitasButton'

const { mapGetters, mapActions } = createNamespacedHelpers('survey')

export default {
  name: 'Footer',
  components: {
    SanitasButton,
  },
  props: {
    // TODO check if this can be removed since always false
    enablePrev: {
      type: Boolean,
      default: false,
    },
    isValid: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    ...mapGetters(['position', 'getAllowDK', 'texts']),
  },
  methods: {
    ...mapActions(['nextPage', 'prevPage']),
    handleClickNextPage() {
      this.isLoading = true
      this.nextPage().finally(() => {
        this.isLoading = false
      })
    },
  },
}
</script>

<style lang="postcss" scoped>
.footer {
  margin-top: auto;
}

.footerActions {
  display: flex;
  justify-content: space-between;
}

.back {
  color: #5bac26;
}

.next {
  margin-left: auto;
}

@media (max-width: 768px) {
  .footerActions {
    margin-top: 40px;
  }

  .back {
    border: 0;
    padding: 0 !important;
  }

  .back:hover {
    color: green;
    background-color: white;
    border: 0;
  }

  .next {
    width: 160px;
  }
}

@media (min-width: 768px) {
  .footerActions {
    margin-top: 60px;
  }

  .back {
    width: 200px;
  }

  .next {
    width: 200px;
  }
}
</style>
